import { render, staticRenderFns } from "./MonthlyLaborRecord.vue?vue&type=template&id=18d72de8"
import script from "./MonthlyLaborRecord.vue?vue&type=script&lang=js"
export * from "./MonthlyLaborRecord.vue?vue&type=script&lang=js"
import style0 from "./MonthlyLaborRecord.vue?vue&type=style&index=0&id=18d72de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports